"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserAgentType = exports.UploadProfilePictureErrorReason = exports.UnfinishedBookingItineraryType = exports.UnauthorizedReason = exports.TripType = exports.TravelInsurance = exports.TransportType = exports.TransactionType = exports.TicketFare = exports.SubmitUserOtpValidationErrorReason = exports.StationType = exports.StartUserOtpValidationErrorReason = exports.SortOrder = exports.ServicePackage = exports.SeatType = exports.ReferFriendStatus = exports.PromotionContentType = exports.PromotionContentGroup = exports.PromoCodeStatus = exports.PriceAlertItineraryType = exports.PreferredTripKind = exports.PreferredRegionName = exports.PlaneArea = exports.OrbitVendorEnum = exports.NotificationBadge = exports.LocationType = exports.LaunchpadVendorEnum = exports.InsuranceType = exports.Gender = exports.FlightAncillariesPreferencesTripType = exports.FareLockStatus = exports.Event = exports.ElementType = exports.DestinationImageDimensions = exports.DaysOfWeekEnum = exports.CustomerBookingsOnlyEnum = exports.CheckedBaggage = exports.CarrierType = exports.CardErrorReason = exports.CabinClassType = exports.CabinBag = exports.BookingStatus = exports.BookingDisplayStatus = exports.BillingAddressErrorReason = exports.BaggageType = exports.BaggagePreferencesType = exports.AncillaryBundle = exports.AgeCategory = exports.AffiliateIdType = exports.ActionNeeded = void 0;
/** All built-in and custom scalars, mapped to their actual values */
let ActionNeeded = exports.ActionNeeded = /*#__PURE__*/function (ActionNeeded) {
  ActionNeeded["Critical"] = "CRITICAL";
  ActionNeeded["DetailsMissing"] = "DETAILS_MISSING";
  ActionNeeded["None"] = "NONE";
  return ActionNeeded;
}({});
let AffiliateIdType = exports.AffiliateIdType = /*#__PURE__*/function (AffiliateIdType) {
  AffiliateIdType["DiscountBooking"] = "DISCOUNT_BOOKING";
  AffiliateIdType["FreeBooking"] = "FREE_BOOKING";
  return AffiliateIdType;
}({});
let AgeCategory = exports.AgeCategory = /*#__PURE__*/function (AgeCategory) {
  AgeCategory["Adult"] = "ADULT";
  AgeCategory["Child"] = "CHILD";
  AgeCategory["Infant"] = "INFANT";
  return AgeCategory;
}({});
let AncillaryBundle = exports.AncillaryBundle = /*#__PURE__*/function (AncillaryBundle) {
  AncillaryBundle["AllIn"] = "ALL_IN";
  AncillaryBundle["Comfort"] = "COMFORT";
  AncillaryBundle["Light"] = "LIGHT";
  return AncillaryBundle;
}({});
let BaggagePreferencesType = exports.BaggagePreferencesType = /*#__PURE__*/function (BaggagePreferencesType) {
  BaggagePreferencesType["CabinBag"] = "CABIN_BAG";
  BaggagePreferencesType["CheckedBag"] = "CHECKED_BAG";
  BaggagePreferencesType["PersonalItem"] = "PERSONAL_ITEM";
  return BaggagePreferencesType;
}({});
let BaggageType = exports.BaggageType = /*#__PURE__*/function (BaggageType) {
  BaggageType["HandBag"] = "HAND_BAG";
  BaggageType["HoldBag"] = "HOLD_BAG";
  BaggageType["PersonalItem"] = "PERSONAL_ITEM";
  return BaggageType;
}({});
/** Reason for adding billing address failed, please extend with possible reasons so we can handle them accordingly on FE */
let BillingAddressErrorReason = exports.BillingAddressErrorReason = /*#__PURE__*/function (BillingAddressErrorReason) {
  BillingAddressErrorReason["AddressNotFound"] = "ADDRESS_NOT_FOUND";
  BillingAddressErrorReason["InvalidId"] = "INVALID_ID";
  BillingAddressErrorReason["NoInput"] = "NO_INPUT";
  return BillingAddressErrorReason;
}({});
let BookingDisplayStatus = exports.BookingDisplayStatus = /*#__PURE__*/function (BookingDisplayStatus) {
  BookingDisplayStatus["Cancelled"] = "CANCELLED";
  BookingDisplayStatus["ChangeInProgress"] = "CHANGE_IN_PROGRESS";
  BookingDisplayStatus["Confirmed"] = "CONFIRMED";
  BookingDisplayStatus["Locked"] = "LOCKED";
  BookingDisplayStatus["NotBooked"] = "NOT_BOOKED";
  BookingDisplayStatus["Processing"] = "PROCESSING";
  BookingDisplayStatus["Refunded"] = "REFUNDED";
  BookingDisplayStatus["Refunding"] = "REFUNDING";
  BookingDisplayStatus["Traveled"] = "TRAVELED";
  return BookingDisplayStatus;
}({});
let BookingStatus = exports.BookingStatus = /*#__PURE__*/function (BookingStatus) {
  BookingStatus["Cancelled"] = "CANCELLED";
  BookingStatus["Closed"] = "CLOSED";
  BookingStatus["Confirmed"] = "CONFIRMED";
  BookingStatus["Failed"] = "FAILED";
  BookingStatus["Pending"] = "PENDING";
  BookingStatus["Refunded"] = "REFUNDED";
  BookingStatus["Traveled"] = "TRAVELED";
  return BookingStatus;
}({});
let CabinBag = exports.CabinBag = /*#__PURE__*/function (CabinBag) {
  CabinBag["CabinBag"] = "CABIN_BAG";
  CabinBag["CabinBagWithPriority"] = "CABIN_BAG_WITH_PRIORITY";
  CabinBag["PersonalItem"] = "PERSONAL_ITEM";
  return CabinBag;
}({});
let CabinClassType = exports.CabinClassType = /*#__PURE__*/function (CabinClassType) {
  CabinClassType["Business"] = "BUSINESS";
  CabinClassType["Economy"] = "ECONOMY";
  CabinClassType["FirstClass"] = "FIRST_CLASS";
  CabinClassType["PremiumEconomy"] = "PREMIUM_ECONOMY";
  return CabinClassType;
}({});
let CardErrorReason = exports.CardErrorReason = /*#__PURE__*/function (CardErrorReason) {
  CardErrorReason["DuplicateCard"] = "DUPLICATE_CARD";
  CardErrorReason["InvalidToken"] = "INVALID_TOKEN";
  return CardErrorReason;
}({});
let CarrierType = exports.CarrierType = /*#__PURE__*/function (CarrierType) {
  CarrierType["Airline"] = "AIRLINE";
  CarrierType["Bus"] = "BUS";
  CarrierType["Ferry"] = "FERRY";
  CarrierType["PrivateTransfer"] = "PRIVATE_TRANSFER";
  CarrierType["Train"] = "TRAIN";
  return CarrierType;
}({});
let CheckedBaggage = exports.CheckedBaggage = /*#__PURE__*/function (CheckedBaggage) {
  CheckedBaggage["NoBaggage"] = "NO_BAGGAGE";
  CheckedBaggage["OneBaggage"] = "ONE_BAGGAGE";
  CheckedBaggage["TwoBaggage"] = "TWO_BAGGAGE";
  return CheckedBaggage;
}({});
let CustomerBookingsOnlyEnum = exports.CustomerBookingsOnlyEnum = /*#__PURE__*/function (CustomerBookingsOnlyEnum) {
  CustomerBookingsOnlyEnum["Future"] = "FUTURE";
  CustomerBookingsOnlyEnum["Past"] = "PAST";
  return CustomerBookingsOnlyEnum;
}({});
let DaysOfWeekEnum = exports.DaysOfWeekEnum = /*#__PURE__*/function (DaysOfWeekEnum) {
  DaysOfWeekEnum["Friday"] = "FRIDAY";
  DaysOfWeekEnum["Monday"] = "MONDAY";
  DaysOfWeekEnum["Saturday"] = "SATURDAY";
  DaysOfWeekEnum["Sunday"] = "SUNDAY";
  DaysOfWeekEnum["Thursday"] = "THURSDAY";
  DaysOfWeekEnum["Tuesday"] = "TUESDAY";
  DaysOfWeekEnum["Wednesday"] = "WEDNESDAY";
  return DaysOfWeekEnum;
}({});
let DestinationImageDimensions = exports.DestinationImageDimensions = /*#__PURE__*/function (DestinationImageDimensions) {
  DestinationImageDimensions["220x165"] = "_220x165";
  DestinationImageDimensions["275x250"] = "_275x250";
  DestinationImageDimensions["300x165"] = "_300x165";
  DestinationImageDimensions["375x165"] = "_375x165";
  DestinationImageDimensions["600x330"] = "_600x330";
  DestinationImageDimensions["600x600"] = "_600x600";
  DestinationImageDimensions["610x251"] = "_610x251";
  DestinationImageDimensions["1200x628"] = "_1200x628";
  DestinationImageDimensions["1280x720"] = "_1280x720";
  return DestinationImageDimensions;
}({});
/** Russia requires first, middle and last. China requires only one full name */
let ElementType = exports.ElementType = /*#__PURE__*/function (ElementType) {
  ElementType["Button"] = "BUTTON";
  ElementType["PromoCode"] = "PROMO_CODE";
  ElementType["Text"] = "TEXT";
  return ElementType;
}({});
let Event = exports.Event = /*#__PURE__*/function (Event) {
  Event["AndroidUsed"] = "ANDROID_USED";
  Event["IosUsed"] = "IOS_USED";
  Event["WebUsed"] = "WEB_USED";
  return Event;
}({});
let FareLockStatus = exports.FareLockStatus = /*#__PURE__*/function (FareLockStatus) {
  FareLockStatus["Active"] = "ACTIVE";
  FareLockStatus["Confirmed"] = "CONFIRMED";
  FareLockStatus["Expired"] = "EXPIRED";
  FareLockStatus["Processing"] = "PROCESSING";
  FareLockStatus["Refunded"] = "REFUNDED";
  return FareLockStatus;
}({});
let FlightAncillariesPreferencesTripType = exports.FlightAncillariesPreferencesTripType = /*#__PURE__*/function (FlightAncillariesPreferencesTripType) {
  FlightAncillariesPreferencesTripType["ExtendedTrip"] = "EXTENDED_TRIP";
  FlightAncillariesPreferencesTripType["ShortTrip"] = "SHORT_TRIP";
  FlightAncillariesPreferencesTripType["WeekLongTrip"] = "WEEK_LONG_TRIP";
  return FlightAncillariesPreferencesTripType;
}({});
let Gender = exports.Gender = /*#__PURE__*/function (Gender) {
  Gender["Female"] = "FEMALE";
  Gender["Male"] = "MALE";
  return Gender;
}({});
let InsuranceType = exports.InsuranceType = /*#__PURE__*/function (InsuranceType) {
  InsuranceType["Basic"] = "BASIC";
  InsuranceType["Plus"] = "PLUS";
  return InsuranceType;
}({});
let LaunchpadVendorEnum = exports.LaunchpadVendorEnum = /*#__PURE__*/function (LaunchpadVendorEnum) {
  LaunchpadVendorEnum["Amex"] = "amex";
  LaunchpadVendorEnum["Dinersclub"] = "dinersclub";
  LaunchpadVendorEnum["Discover"] = "discover";
  LaunchpadVendorEnum["Elo"] = "elo";
  LaunchpadVendorEnum["Jcb"] = "jcb";
  LaunchpadVendorEnum["Maestro"] = "maestro";
  LaunchpadVendorEnum["Mastercard"] = "mastercard";
  LaunchpadVendorEnum["Mir"] = "mir";
  LaunchpadVendorEnum["Unionpay"] = "unionpay";
  LaunchpadVendorEnum["Visa"] = "visa";
  return LaunchpadVendorEnum;
}({});
let LocationType = exports.LocationType = /*#__PURE__*/function (LocationType) {
  LocationType["CityRadius"] = "CITY_RADIUS";
  LocationType["Id"] = "ID";
  LocationType["Radius"] = "RADIUS";
  return LocationType;
}({});
let NotificationBadge = exports.NotificationBadge = /*#__PURE__*/function (NotificationBadge) {
  NotificationBadge["Important"] = "IMPORTANT";
  NotificationBadge["Info"] = "INFO";
  NotificationBadge["Requested"] = "REQUESTED";
  NotificationBadge["Resolved"] = "RESOLVED";
  return NotificationBadge;
}({});
let OrbitVendorEnum = exports.OrbitVendorEnum = /*#__PURE__*/function (OrbitVendorEnum) {
  OrbitVendorEnum["Amex"] = "Amex";
  OrbitVendorEnum["ChinaUnionPay"] = "ChinaUnionPay";
  OrbitVendorEnum["DinersClub"] = "DinersClub";
  OrbitVendorEnum["Discover"] = "Discover";
  OrbitVendorEnum["Jcb"] = "JCB";
  OrbitVendorEnum["Mir"] = "MIR";
  OrbitVendorEnum["Maestro"] = "Maestro";
  OrbitVendorEnum["MaestroShort"] = "MaestroShort";
  OrbitVendorEnum["MasterCard"] = "MasterCard";
  OrbitVendorEnum["MasterCardShort"] = "MasterCardShort";
  OrbitVendorEnum["Visa"] = "Visa";
  return OrbitVendorEnum;
}({});
let PlaneArea = exports.PlaneArea = /*#__PURE__*/function (PlaneArea) {
  PlaneArea["Back"] = "BACK";
  PlaneArea["Front"] = "FRONT";
  PlaneArea["Middle"] = "MIDDLE";
  PlaneArea["NoPreference"] = "NO_PREFERENCE";
  return PlaneArea;
}({});
let PreferredRegionName = exports.PreferredRegionName = /*#__PURE__*/function (PreferredRegionName) {
  PreferredRegionName["Africa"] = "AFRICA";
  PreferredRegionName["Asia"] = "ASIA";
  PreferredRegionName["Domestic"] = "DOMESTIC";
  PreferredRegionName["Europe"] = "EUROPE";
  PreferredRegionName["NorthAmerica"] = "NORTH_AMERICA";
  PreferredRegionName["Oceania"] = "OCEANIA";
  PreferredRegionName["SouthAmerica"] = "SOUTH_AMERICA";
  return PreferredRegionName;
}({});
let PreferredTripKind = exports.PreferredTripKind = /*#__PURE__*/function (PreferredTripKind) {
  PreferredTripKind["Activities"] = "ACTIVITIES";
  PreferredTripKind["Adventure"] = "ADVENTURE";
  PreferredTripKind["Beach"] = "BEACH";
  PreferredTripKind["Events"] = "EVENTS";
  PreferredTripKind["FamilyFun"] = "FAMILY_FUN";
  PreferredTripKind["Music"] = "MUSIC";
  PreferredTripKind["Nature"] = "NATURE";
  PreferredTripKind["Nightlife"] = "NIGHTLIFE";
  PreferredTripKind["Romance"] = "ROMANCE";
  PreferredTripKind["ShortBreak"] = "SHORT_BREAK";
  PreferredTripKind["SightseeingAndCulture"] = "SIGHTSEEING_AND_CULTURE";
  PreferredTripKind["Sports"] = "SPORTS";
  return PreferredTripKind;
}({});
let PriceAlertItineraryType = exports.PriceAlertItineraryType = /*#__PURE__*/function (PriceAlertItineraryType) {
  PriceAlertItineraryType["Multicity"] = "MULTICITY";
  PriceAlertItineraryType["OneWay"] = "ONE_WAY";
  PriceAlertItineraryType["Return"] = "RETURN";
  return PriceAlertItineraryType;
}({});
let PromoCodeStatus = exports.PromoCodeStatus = /*#__PURE__*/function (PromoCodeStatus) {
  PromoCodeStatus["Expired"] = "EXPIRED";
  PromoCodeStatus["Used"] = "USED";
  PromoCodeStatus["Valid"] = "VALID";
  return PromoCodeStatus;
}({});
let PromotionContentGroup = exports.PromotionContentGroup = /*#__PURE__*/function (PromotionContentGroup) {
  PromotionContentGroup["Reminder"] = "REMINDER";
  PromotionContentGroup["TipsAndTricks"] = "TIPS_AND_TRICKS";
  PromotionContentGroup["UpcomingTrip"] = "UPCOMING_TRIP";
  return PromotionContentGroup;
}({});
let PromotionContentType = exports.PromotionContentType = /*#__PURE__*/function (PromotionContentType) {
  PromotionContentType["AddTraveler"] = "ADD_TRAVELER";
  PromotionContentType["AppPromotion"] = "APP_PROMOTION";
  PromotionContentType["AutoCheckIn"] = "AUTO_CHECK_IN";
  PromotionContentType["CreditsExpiration"] = "CREDITS_EXPIRATION";
  PromotionContentType["NotificationsSettings"] = "NOTIFICATIONS_SETTINGS";
  PromotionContentType["PaymentCardExpired"] = "PAYMENT_CARD_EXPIRED";
  PromotionContentType["ReferFriend"] = "REFER_FRIEND";
  PromotionContentType["RegionalSettings"] = "REGIONAL_SETTINGS";
  PromotionContentType["TravelDocumentExpired"] = "TRAVEL_DOCUMENT_EXPIRED";
  PromotionContentType["TravelDocumentRequired"] = "TRAVEL_DOCUMENT_REQUIRED";
  return PromotionContentType;
}({});
let ReferFriendStatus = exports.ReferFriendStatus = /*#__PURE__*/function (ReferFriendStatus) {
  ReferFriendStatus["Done"] = "DONE";
  ReferFriendStatus["Inviter"] = "INVITER";
  ReferFriendStatus["Registered"] = "REGISTERED";
  return ReferFriendStatus;
}({});
let SeatType = exports.SeatType = /*#__PURE__*/function (SeatType) {
  SeatType["Aisle"] = "AISLE";
  SeatType["Middle"] = "MIDDLE";
  SeatType["NoPreference"] = "NO_PREFERENCE";
  SeatType["Window"] = "WINDOW";
  return SeatType;
}({});
let ServicePackage = exports.ServicePackage = /*#__PURE__*/function (ServicePackage) {
  ServicePackage["Basic"] = "BASIC";
  ServicePackage["Plus"] = "PLUS";
  ServicePackage["Premium"] = "PREMIUM";
  return ServicePackage;
}({});
let SortOrder = exports.SortOrder = /*#__PURE__*/function (SortOrder) {
  SortOrder["Ascending"] = "ASCENDING";
  SortOrder["Descending"] = "DESCENDING";
  return SortOrder;
}({});
let StartUserOtpValidationErrorReason = exports.StartUserOtpValidationErrorReason = /*#__PURE__*/function (StartUserOtpValidationErrorReason) {
  StartUserOtpValidationErrorReason["EmailExists"] = "EMAIL_EXISTS";
  StartUserOtpValidationErrorReason["GeneralError"] = "GENERAL_ERROR";
  StartUserOtpValidationErrorReason["TooManyAttempts"] = "TOO_MANY_ATTEMPTS";
  return StartUserOtpValidationErrorReason;
}({});
let StationType = exports.StationType = /*#__PURE__*/function (StationType) {
  StationType["Airport"] = "AIRPORT";
  StationType["Bus"] = "BUS";
  StationType["Train"] = "TRAIN";
  return StationType;
}({});
let SubmitUserOtpValidationErrorReason = exports.SubmitUserOtpValidationErrorReason = /*#__PURE__*/function (SubmitUserOtpValidationErrorReason) {
  SubmitUserOtpValidationErrorReason["PasscodeExpired"] = "PASSCODE_EXPIRED";
  SubmitUserOtpValidationErrorReason["PasscodeWrong"] = "PASSCODE_WRONG";
  SubmitUserOtpValidationErrorReason["TooManyAttempts"] = "TOO_MANY_ATTEMPTS";
  return SubmitUserOtpValidationErrorReason;
}({});
let TicketFare = exports.TicketFare = /*#__PURE__*/function (TicketFare) {
  TicketFare["Flexi"] = "FLEXI";
  TicketFare["Saver"] = "SAVER";
  TicketFare["Standard"] = "STANDARD";
  return TicketFare;
}({});
let TransactionType = exports.TransactionType = /*#__PURE__*/function (TransactionType) {
  TransactionType["Deposit"] = "DEPOSIT";
  TransactionType["Expiration"] = "EXPIRATION";
  TransactionType["Payment"] = "PAYMENT";
  TransactionType["Refund"] = "REFUND";
  return TransactionType;
}({});
let TransportType = exports.TransportType = /*#__PURE__*/function (TransportType) {
  TransportType["Bus"] = "BUS";
  TransportType["Flight"] = "FLIGHT";
  TransportType["Train"] = "TRAIN";
  return TransportType;
}({});
let TravelInsurance = exports.TravelInsurance = /*#__PURE__*/function (TravelInsurance) {
  TravelInsurance["NoInsurance"] = "NO_INSURANCE";
  TravelInsurance["TravelBasic"] = "TRAVEL_BASIC";
  TravelInsurance["TravelPlus"] = "TRAVEL_PLUS";
  TravelInsurance["TravelPlusUs"] = "TRAVEL_PLUS_US";
  return TravelInsurance;
}({});
let TripType = exports.TripType = /*#__PURE__*/function (TripType) {
  TripType["Future"] = "FUTURE";
  TripType["Past"] = "PAST";
  return TripType;
}({});
let UnauthorizedReason = exports.UnauthorizedReason = /*#__PURE__*/function (UnauthorizedReason) {
  UnauthorizedReason["EmptyToken"] = "EMPTY_TOKEN";
  UnauthorizedReason["InvalidToken"] = "INVALID_TOKEN";
  UnauthorizedReason["MalformedToken"] = "MALFORMED_TOKEN";
  UnauthorizedReason["MissingToken"] = "MISSING_TOKEN";
  UnauthorizedReason["Unknown"] = "UNKNOWN";
  UnauthorizedReason["WhitespaceToken"] = "WHITESPACE_TOKEN";
  return UnauthorizedReason;
}({});
let UnfinishedBookingItineraryType = exports.UnfinishedBookingItineraryType = /*#__PURE__*/function (UnfinishedBookingItineraryType) {
  UnfinishedBookingItineraryType["Multicity"] = "MULTICITY";
  UnfinishedBookingItineraryType["Nomad"] = "NOMAD";
  UnfinishedBookingItineraryType["OneWay"] = "ONE_WAY";
  UnfinishedBookingItineraryType["Return"] = "RETURN";
  return UnfinishedBookingItineraryType;
}({});
/** Reason for upload picture failed, please extend with possible reasons so we can handle them accordingly on FE */
let UploadProfilePictureErrorReason = exports.UploadProfilePictureErrorReason = /*#__PURE__*/function (UploadProfilePictureErrorReason) {
  UploadProfilePictureErrorReason["FileTypeError"] = "FILE_TYPE_ERROR";
  UploadProfilePictureErrorReason["UpstreamError"] = "UPSTREAM_ERROR";
  return UploadProfilePictureErrorReason;
}({});
let UserAgentType = exports.UserAgentType = /*#__PURE__*/function (UserAgentType) {
  UserAgentType["Bot"] = "BOT";
  UserAgentType["EmailClient"] = "EMAIL_CLIENT";
  UserAgentType["Mobile"] = "MOBILE";
  UserAgentType["Pc"] = "PC";
  UserAgentType["Tablet"] = "TABLET";
  UserAgentType["Unknown"] = "UNKNOWN";
  return UserAgentType;
}({});